import { ReactComponent as MapPinSvg } from '../../../../assets/icons/MapPin.svg';

import { createIconComponent } from './createIconComponent';

export const MapPinIcon = createIconComponent(MapPinSvg);
